export class LocationByPlant{
    plant?:number;

    constructor(
        plant?: number,
    ) {
        this.plant = plant;
    }
}